import { PUBLIC_DIFFUSION_API_ENDPOINT } from '$env/static/public';
import { Client as DiffusionApiClient, type PlanInformation } from '$lib/diffusionApi';

export default class PlanInformationClient {
	private diffusionApiClient: DiffusionApiClient;

	constructor(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public setToken(token: string) {
		this.diffusionApiClient = new DiffusionApiClient({
			BASE: PUBLIC_DIFFUSION_API_ENDPOINT,
			TOKEN: token
		});
	}

	public async getPlanInformation(): Promise<PlanInformation | undefined> {
		try {
			const response = await this.diffusionApiClient.default.getPlanInformationPlanInformationGet();
			return response.plan_information;
		} catch (error) {
			console.error(error);
			return undefined;
		}
	}
}
